import React, { useState } from "react";
import { ChevronDown, RefreshCw } from "lucide-react";

interface SidepeekDetailsAccordionProps {
  title: string;
  children: React.ReactNode;
  onRefresh?: () => void;
}

const SidepeekDetailsAccordion: React.FC<SidepeekDetailsAccordionProps> = ({
  title,
  children,
  onRefresh,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <section className="flex w-full flex-col items-start gap-3 px-4">
      <div className="flex w-full items-center justify-between">
        <button
          type="button"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
          className="flex min-w-0 flex-1 items-center gap-2 text-left"
        >
          <ChevronDown
            size={16}
            strokeWidth={2}
            className={`shrink-0 text-[#737373] transition-transform ${
              isOpen ? "rotate-0" : "-rotate-90"
            }`}
          />

          <span className="truncate text-[12px] font-medium leading-none text-[#0A0A0A]">
            {title}
          </span>
        </button>

        {onRefresh && (
          <button
            type="button"
            onClick={onRefresh}
            aria-label={`Refresh ${title}`}
            className="flex h-6 w-6 shrink-0 items-center justify-center rounded text-[#737373] transition-colors hover:bg-[#F5F5F5]"
          >
            <RefreshCw size={16} strokeWidth={1.33333} />
          </button>
        )}
      </div>

      {isOpen && (
        <div className="flex w-full flex-col items-start">
          {children}
        </div>
      )}
    </section>
  );
};

export default SidepeekDetailsAccordion;